'use strict'

updateUrl = (pageNumber, pageParamName) ->
  return unless window.history?.replaceState?

  queryParams = window.location.href.split('?')[1]
  newParams = ''

  if queryParams?
    newParamsArray = []
    pageParamSpecified = false

    queryParamsList = queryParams.split('&')
    queryParamsList.forEach (param) ->
      if param.split('=')[0] is pageParamName
        newParamsArray.push "#{pageParamName}=#{pageNumber}" if pageNumber > 1
        pageParamSpecified = true
      else
        newParamsArray.push param if param?.length > 0

    if not pageParamSpecified and pageNumber > 1
      newParamsArray.push "#{pageParamName}=#{pageNumber}"

    newParams = if newParamsArray.length > 0 then "?#{newParamsArray.join('&')}" else ''

  else
    newParams = "?#{pageParamName}=#{pageNumber}" if pageNumber > 1

  newUrl = "#{window.location.origin}#{window.location.pathname}#{newParams}"
  window.history.replaceState '', '', newUrl

module.exports = { updateUrl }
